import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import { formStyleConstants } from '../../utils/constants/form-style-constants';
import FieldHeader from './FieldHeader';
import { formMessageConstants } from '../../utils/constants/form-message-constants';

class FormSelectField extends Component {
    constructor(props) {
        super(props);
        const { defaultValue, options } = props;
        const selectedOption = options.find((option) => option.code === defaultValue) || {};
        this.state = { defaultValue, selectedOption };

        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.defaultValue === nextProps.defaultValue) {
            return;
        }
        const { defaultValue, options } = nextProps;
        const selectedOption = options.find((option) => option.code === defaultValue) || {};

        this.setState((state) => ({ ...state, defaultValue: nextProps.defaultValue, selectedOption }));
    }

    handleChange(event) {
        const { onChange, options } = this.props;
        const { value } = event.target;
        const selectedOption = options.find((option) => option.code === value) || {};
        this.setState((state) => ({ ...state, defaultValue: value, selectedOption }));
        onChange(event);
    }

    render() {
        const {
            name,
            label,
            isHidden,
            headerTitle,
            headerText,
            size,
            isDisabled,
            options,
            propertyForValue,
            validState,
            formRef
        } = this.props;
        const { defaultValue, selectedOption } = this.state;
        const { isValid, errorMessage } = validState || { isValid: true };
        const fieldClassName = name || formStyleConstants.customFieldClassName;

        return (
            <Fragment>
                <FieldHeader fieldName={name} headerTitle={headerTitle} headerText={headerText}>
                </FieldHeader>
                <div
                    ref={formRef}
                    className={`form-select auto-mt-xs ${fieldClassName.toLowerCase()}-field ${size || formMessageConstants.emptyString} ${!isValid ? formStyleConstants.isInvalid : ''}`}
                    style={{ display: isHidden ? 'none' : 'block' }}>
                    {selectedOption.flag && <img src={selectedOption.flag.src} alt="flag" ></img>}
                    <select
                        className={`form-select__select ${selectedOption.flag ? 'has-flag' : 'no-flag'}`}
                        id={name}
                        disabled={isDisabled}
                        name={name}
                        required='required'
                        placeholder={label}
                        onChange={this.handleChange}
                        value={`${defaultValue}`}>
                        <option className='form-select__option' value='None'>
                            {label}
                        </option>
                        {options.map((option) => {
                            return (
                                <option
                                    key={uniqueId()}
                                    className='form-select__option'
                                    value={option[propertyForValue]}>
                                    {option.label}
                                </option>
                            );
                        })
                        }
                    </select>
                    <svg
                        className='form-select__arrow-down'
                        height='6'
                        width='14'>
                        <use xlinkHref='#icon-arrow-down'></use>
                    </svg>
                    {!isValid ? <ul className='form-field__error-list filled'>
                        <li className='form-field__error-item'>{errorMessage}</li>
                    </ul> : null}
                </div>
            </Fragment >);
    }
}

FormSelectField.propTypes = {
    formRef: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    headerTitle: PropTypes.string,
    headerText: PropTypes.string,
    size: PropTypes.string,
    options: PropTypes.array.isRequired,
    propertyForValue: PropTypes.string.isRequired,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    validState: PropTypes.object
};

export default FormSelectField;
